export const FETCH_SERVICES = "FETCH_SERVICES";
export const SET_SERVICES = "SET_SERVICES";
export const FETCH_DISABLED_SLOTS = "FETCH_DISABLED_SLOTS";
export const SET_DISABLED_SLOTS = "SET_DISABLED_SLOTS";
export const INITIALIZE_PAYMENT = "INITIALIZE_PAYMENT";
export const CREATE_ORDER = "CREATE_ORDER";
